import React, { useEffect, useState, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import Hero from "src/components/Hero/Hero";
import SectionalTabs from "src/components/SectionalTabs/SectionalTabs";
import TabContent from "src/components/EatAndPlay/TabContent";
import Markdown from "src/components/Markdown";

const EatAndPlay = () => {

  const { i18n, t } = useTranslation();
  const location = useLocation();

  const routeCategory = "eatAndPlay"; // Define the routeCategory
  const categories = require(`src/locales/${i18n.language}/pseudoRoutes.json`);
  const categoryArr = useMemo(() => Object.values(categories.pseudoRoutes[routeCategory] || {}), [i18n.language]);

  // Manage selected category and active path
  const [selectedCategory, setSelectedCategory] = useState({
    key: Object.keys(categories.pseudoRoutes[routeCategory])[0] || "",
    title: categoryArr[0]?.title || "",
    path: categoryArr[0]?.path || ""
  });


  useEffect(() => {
    const currentTab = categoryArr.find((el) => el.path === location.pathname);
    const currentTabKey = currentTab ?
      Object.keys(categories.pseudoRoutes[routeCategory]).find(
        key => categories.pseudoRoutes[routeCategory][key].path === currentTab.path
      ) : null;

    // If the user lands on `/eatAndPlay`, show the first tab content and mark it as active without navigating
    if (location.pathname === t("routes.eatAndPlay") && categoryArr[0] && selectedCategory.path !== categoryArr[0].path) {
      setSelectedCategory({
        key: Object.keys(categories.pseudoRoutes[routeCategory])[0] || "",
        title: categoryArr[0].title,
        path: categoryArr[0].path
      });
    }

    // If a valid tab is in the URL, set it as selectedCategory
    if (currentTab && currentTab.path !== selectedCategory.path && currentTabKey) {
      setSelectedCategory({
        key: currentTabKey,
        title: currentTab.title,
        path: currentTab.path
      });
    }
  }, [location.pathname, categoryArr, selectedCategory.path, categories.pseudoRoutes, routeCategory]);


  return (
    <SnackAndSpinDiv>
      <Hero
        bgColor=""
        bgImage={"poker/eat-and-play-hero-bg-2.jpg"}
        buttonLink=""
        buttonText=""
        description={t("eatAndPlay.hero.description")}
        descriptionBgColor=""
        image=""
        imageAlt=""
        mainHeroText={t("eatAndPlay.hero.title")}
        title=""
      />
      <container-div>
        <Markdown className="white text-center mt-4">
          {t("eatAndPlay.banner")}
        </Markdown>
      </container-div>

      <SecondPart>
        <container-wide>
          <SectionalTabs
            className="mt-4 mb-4"
            routeData={{
              route: t(`routes.${routeCategory}`),
              routeCategory,
              sectionTitle: categoryArr[0]?.title || "",
              selectCategory: location.pathname === t("routes.egdGameList") ? categoryArr[0]?.title : selectedCategory.title, // Highlight first tab when on the base route
            }}
            isDynamic={true}
            selectedCategory={selectedCategory.title} // Active category
            bgColor="var(--mutedred)"
            textColor="var(--white)"
            activeBgColor="var(--red)"
            activeTextColor="var(--white)"
          />
        </container-wide>

        {selectedCategory.key && <TabContent categoryKey={selectedCategory.key} t={t} />}

      </SecondPart>
    </SnackAndSpinDiv>
  );
};

const SnackAndSpinDiv = styled.div`
  width: 100%;
  background: var(--black);
`;

const SecondPart = styled.div`
  .tabs-row {
    button {
      margin: 0;
    }
  }
  height: auto;
  width: 100%;
  background: var(--black);
  color: var(--white);
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  letter-spacing: 1px;
  overflow-x: hidden;

`;

export default EatAndPlay;
